module.exports = __webpack_public_path__ + "img/contractorApp.413556dc.png";